/**
 * The copy for 3002's "Benefits" section, which replaces its Core benefits section when
 * `Sales-isRichBenefitsEnabled` is on. Defined here in code, so a wording change is a code change.
 *
 * Markdown conventions that RichBenefitsSection.module.css styles:
 *   - `### ` starts a page: a heading, then its script.
 *   - `==...==` is what the expert says word for word (the shared purple highlight); quotation marks
 *     sit outside the token.
 *   - `*...*` is a cue for the expert only (not spoken).
 *   - `____` is a blank to personalise from discovery.
 *   - a closing `> ` blockquote is the Guidance callout.
 */
export const RICH_BENEFITS_MARKDOWN = `\
### Page 1 · What it covers

*Reference the images on this page.*

“==On this first page there are a few pictures of what we cover. This plan covers breakdowns on all eligible products for one monthly price, no matter when you purchased them or what company you purchased them from.==”

“==So, your eligible devices like== ____ ==are covered under the one plan.==”

*Name the devices the customer uncovered.*

### Page 2 · How we take care of it

“==On the next page you’ll see how we take care of those devices. We know how easy it is to drop those devices we all carry around, so we cover drops and spills for portable eligible devices as well.==”

“Like… ____”

*Personalize with the eligible devices you discovered.*

### Page 3 · What comes with it

“==The last page shows what comes with it, like two in-home visits a year, and future purchases of eligible devices are covered.==”

*You can use another relevant convenience benefit instead.*

> **Guidance:** Tie in what you uncovered about the customer’s lifestyle.`;
